<template>
<v-container class="cmp-settings-billing-billing_settings dt-sidewindow submodule-root">
  <div class="dt-tabs-container submodule-root">
    <glayout      
      :tabs="billingSettingsTabs"
      tabPanelColor="secondary"
    >
      <gtab id="overview">
        <template #header>
          <grow>
            <gcol>
              <div style="margin-top:5px">
                <button
                  style="margin-left: -15px"
                  class="dt-button v5 s8"
                 @click="updateBillingInfo()"
                >
                  {{$t('update_billing_information')}}
                </button>
                </div>
              </gcol>
            </grow>
        </template>
        <grow>
          <gcol>
            <gbox
              
              :h="boxHeightNamed({
                    rowCount:
                      billingSettingsData &&
                      billingSettingsData.payment &&
                      billingSettingsData.payment.length,
                    offset: NTOffsets.withHeaderDBoxBottom,
                    rowHeight:32,
                    max:10,
                    min: 1
                  })"
              :title="$t('invoice')"
            >
              <InvoiceList :billingSettingsData="billingSettingsData"/>
            </gbox>
          </gcol>
        </grow>
        <grow>
          <gcol>
            <gbox
             :h="boxHeightNamed({
                    rowCount:
                      billingSettingsData &&
                      billingSettingsData.support &&
                      billingSettingsData.support.length,
                    offset: NTOffsets.WithHeader,
                    max:10,
                    min: 1
                  })"
             :title="$t('support_issue')"
            >
              <SupportIssue :billingSettingsData="billingSettingsData" />
            </gbox>
          </gcol>
        </grow>

      </gtab>
    </glayout>
  </div>
</v-container>
</template>


<script>
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";
import { createGridHost, createSidewindowTabulation } from "../../../../dt-plugins/sidewindow";
import { createModalMixin, closeModalRoute, openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";
import QuickModal from "@plugins/quickmodal/quickmodal";
import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import { createTextFieldConfig, EventHooks } from "../../../../plugins/text-field";
import { JSONX } from "../../../../utility";
import { LoadingUI } from "@plugins/loading/loading";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { billingSettingsGrid } from "./sw-grid";
import DTable from "@dtplugins/dtable/dtable";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";
import { HttpClient } from "../../../../services/http/http-client";
import { MHTTPCL } from "../../../../services/http/http-client";
import { createDTGridHost } from '../../../../dt-plugins/dt-grid/dt-grid.mixin';

import InvoiceList from './invoice-list.vue'
import SupportIssue from './support-issue.vue'

export default {
  components: {
    DBox,
    DList,
    DTable,
    QuickModal,
    ModalContainer,
    LoadingUI,
    NTable,
    InvoiceList,
    SupportIssue
  },
  mounted: function () {
    this.fetchData();
  },
  data: function () {
    return {
      gridLayout: billingSettingsGrid,
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),
    };
    //MARK: Data Function
  },
  mixins: [

    createDTGridHost(),


  ],
  computed: {
    ...mapGetters(storeNS, {
      billingSettingsData: "billingSettingsData",
    }),


    billingSettingsTabs: function () {
      return [
        {
          route: "overview",
          value: this.$t('billing'),
        },
      ];
    },
  },

  methods: {
    ...mapKeyToAction(storeNS, [ActionTypes.BillingSettingsData.FETCH.ALL]),
    createNTableConfig: createNTableConfig,
    fetchData: function () {
      this[ActionTypes.BillingSettingsData.FETCH.ALL]();
    },
    tabSelected: function (tabId) {},
    invoiceDate: function (item) {
      return item.timestamped?.split(" ")[0] || "";
    },
    invoicePeriod: function (item) {
      return item.JSON?.invoice_lines?.[0]?.description.slice(31) || "";
    },
    invoiceLink: function (item) {
      return `${HttpClient.getBaseUrl()}/billing.pl?invoice=${item.invoice}&action=display%20invoice`;
    },
    //MARK: Methods

    updateBillingInfo: function () {
      window.open(`${MHTTPCL.getBaseUrl()}/settings.pl?section=billing&action=update_billing_info_adyen_page`, "_blank", "titlebar=no");
    },
  },
};
</script>

<style lang="scss">
.cmp-settings-billing-billing_settings {
  .dt-grid-layout {
    height: calc(100vh - 108px);
  }
.cmp-settings-billing-billing_settings_invoice,
.cmp-settings-billing-support_issue {
  height: 100%;

  .invoice {
    a {
      color: unset;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
}
</style>